import React from 'react'
import { styled } from '@mui/material/styles'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

import Paper from '@mui/material/Paper'

import { cardSx } from './lifeshub-tokens'
import { ActionsRow, EmptyIcon } from './lifeshub-common'

export const LifesHubCard = styled(Paper)({
    ...cardSx,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden'
})

const CardHead = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 20,
    padding: '16px 18px 12px',
    flexShrink: 0
})

const CardTitle = styled('h3')({
    margin: 0,
    fontSize: 16,
    fontWeight: 700,
    color: 'var(--ink)',
    lineHeight: 1.2
})

const CardCount = styled('div')({
    marginTop: 6,
    color: 'var(--green-800)',
    fontWeight: 700,
    fontSize: 12
})

export type LifesHubCardHeaderProps = {
    title: React.ReactNode
    count?: React.ReactNode
    actions?: React.ReactNode
}

export function LifesHubCardHeader({ title, count, actions }: LifesHubCardHeaderProps) {
    return (
        <CardHead>
            <div>
                <CardTitle>{title}</CardTitle>
                {count !== undefined && <CardCount>{count}</CardCount>}
            </div>
            {!!actions && <ActionsRow>{actions}</ActionsRow>}
        </CardHead>
    )
}

export const LifesHubCardBody = styled('div', { shouldForwardProp: (prop) => prop !== 'noHead' })<{
    noHead?: boolean
}>(({ noHead }) => ({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: 0,
    overflow: 'hidden',
    padding: noHead ? 18 : '0 18px 18px'
}))

export default LifesHubCard

const EmptyContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    padding: '40px 20px',
    textAlign: 'center',
    flexGrow: 1,
    minHeight: 0
})

const EmptyTitle = styled('h3')({
    margin: 0,
    fontSize: 16,
    color: 'var(--ink)'
})

const EmptyText = styled('p')({
    margin: 0,
    maxWidth: 420,
    color: 'var(--muted)'
})

const EmptyActions = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginTop: 10
})

export type LifesHubEmptyStateProps = {
    title: string
    text: string
    actions?: React.ReactNode
}

export function LifesHubEmptyState({ title, text, actions }: LifesHubEmptyStateProps) {
    return (
        <EmptyContainer>
            <EmptyIcon>
                <InfoOutlinedIcon />
            </EmptyIcon>
            <EmptyTitle>{title}</EmptyTitle>
            <EmptyText>{text}</EmptyText>
            {!!actions && <EmptyActions>{actions}</EmptyActions>}
        </EmptyContainer>
    )
}
